var exports = {
  "container": "x43cbe9c2--cc198a--container",
  "title": "x43cbe9c2--cc198a--title",
  "socials": "x43cbe9c2--cc198a--socials",
  "social": "x43cbe9c2--cc198a--social",
  "tablet": "x43cbe9c2--cc198a--tablet",
  "phone": "x43cbe9c2--cc198a--phone",
};

module.exports = exports;
